<template>
  <v-row column wrap>
    <v-col cols="12">
      <v-expand-transition>
        <v-card v-show="formShow">
          <v-card-text>
            <v-form ref="form">
              <v-text-field
                type="number"
                v-model="hist.sort"
                name="sort"
                label="Номер по порядку"
              ></v-text-field>
              <v-text-field
                label="Дата"
                :rules="[(v) => !!v || 'Это поле обязательно']"
                v-model="hist.date"
              >
              </v-text-field>
              <v-textarea
                label="Описание"
                :rules="[(v) => !!v || 'Это поле обязательно']"
                v-model="hist.description"
              >
              </v-textarea>
              <input type="text" name="id" v-model="hist.id" style="display: none" />
              <v-btn color="secondary" @click="save">{{ submitButton }}</v-btn>
              <v-btn color="warning" v-show="hist.id > 0" @click="hist = { ...defaultHist }"
                >Очистить</v-btn
              >
            </v-form>
          </v-card-text>
        </v-card>
      </v-expand-transition>
      <v-btn color="secondary" v-show="!formShow" @click="formShow = true"
        >Добавить новую запись</v-btn
      >
    </v-col>

    <v-col cols="12" v-show="historyList">
      <list-view
        :with-sites="false"
        :color="'#538DCB'"
        :items="historyList"
        :items-name="'party/history'"
        :description-field="'description'"
        :title-field="'date'"
        :sortable="false"
        @remove-item="updateData"
        @item-click="itemClick"
      >
        <template v-slot:prepend="{ item }">
          <span>{{ item.sort }}</span>
        </template>
      </list-view>
    </v-col>
  </v-row>
</template>

<script>
import ListView from '@/components/ListView'

export default {
  name: 'history',
  components: { ListView },
  data() {
    return {
      formShow: false,
      historyList: [],
      hist: { date: '', description: '', sort: 0, id: -1 },
      defaultHist: { date: '', description: '', sort: 0, id: -1 },
    }
  },
  computed: {
    submitButton() {
      return this.hist.id > 0 ? 'Сохранить' : 'Добавить'
    },
  },
  mounted() {
    this.updateData()
  },
  methods: {
    itemClick(e) {
      this.$refs.form.$el.scrollIntoView(false)
      this.hist = { ...e }
    },
    updateData() {
      this.axios({ url: '/v1/party/history', method: 'get' })
        .then((resp) => {
          this.historyList = resp.data
          // console.log('groups list', this.groups)
        })
        .catch((err) => {
          this.$log.error(err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    save() {
      if (!this.$refs.form.validate()) {
        return
      }
      const url = this.hist.id > 0 ? `/v1/party/history/${this.hist.id}` : '/v1/party/history'
      this.axios({
        url: url,
        method: this.hist.id > 0 ? 'patch' : 'post',
        data: {
          date: this.hist.date,
          description: this.hist.description,
          sort: Number(this.hist.sort),
        },
      })
        .then((resp) => {
          this.hist = { title: '', description: '', sort: 0, id: -1 }
          this.updateData()
          this.showSnackbar('Сохранено', 'green')
          this.$refs.form.resetValidation()
          this.formShow = false
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
  },
}
</script>

<style scoped lang="scss">
.item {
  margin: 20px;
}

.item__description {
  border-left: 2px solid $main_blue;
  padding-left: 10px;
}
</style>
